var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parameter-validation-form" }, [
    _c(
      "div",
      { staticClass: "entity-picker-section" },
      [
        _c("span", { staticClass: "sectionTitle" }, [
          _vm._v("Parameter validation"),
        ]),
        _vm._v(" "),
        _c(
          "a-popover",
          {
            attrs: {
              trigger: "click",
              overlayClassName: "no-padding",
              placement: "left",
            },
            model: {
              value: _vm.entityPickerVisible,
              callback: function ($$v) {
                _vm.entityPickerVisible = $$v
              },
              expression: "entityPickerVisible",
            },
          },
          [
            _c(
              "div",
              { attrs: { slot: "content" }, slot: "content" },
              [
                _c("ValidationEntityPicker", {
                  attrs: {
                    "default-selected": _vm.clone.validationType,
                    pick: _vm.onValidationEntityPicked,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "entity-input" }, [
              _c("div", { staticClass: "entity-input-text-wrapper" }, [
                _vm.$_.isEmpty(_vm.clone.validationType)
                  ? _c("div", { staticClass: "entity-input-placeholder" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("chatbotv2.selectReplyType")) +
                          "\n                    "
                      ),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "single-entity-style",
                        class: { active: _vm.entityPickerVisible },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                (
                                  "" +
                                  _vm.getValidationEntity(
                                    _vm.clone.validationType
                                  ).value
                                ).startsWith("akinon_") ||
                                  _vm.Attributes.includes(
                                    _vm.getValidationEntity(
                                      _vm.clone.validationType
                                    ).value
                                  )
                                  ? _vm.$t(
                                      "chatbotv2.attr." +
                                        _vm.getValidationEntity(
                                          _vm.clone.validationType
                                        ).value
                                    )
                                  : _vm.Entities.includes(
                                      _vm.getValidationEntity(
                                        _vm.clone.validationType
                                      ).value
                                    )
                                  ? _vm.$t(
                                      "chatbotv2." +
                                        _vm.getValidationEntity(
                                          _vm.clone.validationType
                                        ).value
                                    )
                                  : _vm.getValidationEntity(
                                      _vm.clone.validationType
                                    ).value
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
              ]),
              _vm._v(" "),
              !_vm.$_.isEmpty(_vm.clone.validationType)
                ? _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" expand_more "),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "attribute-picker-section" },
      [
        _c("span", { staticClass: "sectionTitle" }, [
          _vm._v(" Save to Attribute"),
        ]),
        _vm._v(" "),
        _c(
          "a-popover",
          {
            attrs: {
              trigger: "click",
              overlayClassName: "no-padding",
              placement: "left",
            },
            model: {
              value: _vm.attributePickerVisible,
              callback: function ($$v) {
                _vm.attributePickerVisible = $$v
              },
              expression: "attributePickerVisible",
            },
          },
          [
            _c(
              "div",
              { attrs: { slot: "content" }, slot: "content" },
              [
                _c("AttributePicker", {
                  attrs: {
                    "default-selected": _vm.clone.attributeName,
                    pick: _vm.onAttributePicked,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "attribute-input" }, [
              _c("div", { staticClass: "attribute-input-text-wrapper" }, [
                _vm.$_.isEmpty(_vm.clone.attributeName)
                  ? _c("div", { staticClass: "attribute-input-placeholder" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("chatbotv2.chooseAttributeType")) +
                          "\n                    "
                      ),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "single-attribute-style",
                        class: { active: _vm.attributePickerVisible },
                      },
                      [
                        _c("AttributeIconPreview", {
                          attrs: { attribute: _vm.clone.attributeName },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                ("" + _vm.clone.attributeName).startsWith(
                                  "akinon_"
                                ) ||
                                  _vm.Attributes.includes(
                                    _vm.clone.attributeName
                                  )
                                  ? _vm.$t(
                                      "chatbotv2.attr." +
                                        _vm.clone.attributeName
                                    )
                                  : _vm.Entities.includes(
                                      _vm.clone.attributeName
                                    )
                                  ? _vm.$t(
                                      "chatbotv2." + _vm.clone.attributeName
                                    )
                                  : _vm.clone.attributeName.startsWith(
                                      "contact_property_"
                                    )
                                  ? _vm.visitorContactAttributes[
                                      _vm.clone.attributeName.replace(
                                        "contact_property_",
                                        ""
                                      )
                                    ]
                                  : _vm.clone.attributeName
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ],
                      1
                    ),
              ]),
              _vm._v(" "),
              !_vm.$_.isEmpty(_vm.clone.attributeName)
                ? _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" expand_more "),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "buttons-wrapper" },
      [
        _c(
          "a-button",
          { attrs: { size: "large" }, on: { click: _vm.onCancel } },
          [_vm._v(_vm._s(_vm.$t("message.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "a-button",
          {
            attrs: {
              size: "large",
              type: "primary",
              disabled: !_vm.isChanged(),
            },
            on: { click: _vm.save },
          },
          [_vm._v(_vm._s(_vm.$t("message.save")) + "\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }